import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { ErhoeheKreditlinieModel } from '../../../model.module/xhr/erhoehe-kreditlinie.model';
import { AuthService } from '../../../services.module/auth.service';
import { PartnerProfilData } from '../../../../generated/api/kreditportalBackendAPI.schemas';

@Component({
    selector: 'print-kreditlinie-antrag',
    templateUrl: './kreditlinie-antrag.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrintKreditlinieAntrag {

    @Input()
    model: ErhoeheKreditlinieModel = null;

    @Input()
    partner: PartnerProfilData = null;

    @Input()
    shown = false;

    @Input()
    invisibleButton = false;

    kundenName = '';

    constructor(authService: AuthService) {
        this.kundenName = authService.getActiveKundeOnLogin().nameVn;
    }

    notifyOpen(open: boolean): void {
        this.shown = open;
    }

}

